import axios, { AxiosRequestConfig } from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { BannerTypeOutputDTO } from './bannerTypeDTO'
import { IsAuthorized } from 'src/authentication/IsAuthorized'

class BannerTypeServices {
  async getByAll(params: any): Promise<BannerTypeOutputDTO[]> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }

      if (params) {
        config.params = params
      }
      
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/banner-type/`, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const bannerTypeServices = new BannerTypeServices()
